import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ManageListing.css';

// Components
import PanelWrapper from '../../components/ManageListing/PanelWrapper';
import Loader from '../../components/Loader';

// GraphQL
import { withQuery } from '../../hoc/withGraphql';
import ManageListingsQuery from './manageListing.graphql';

const ManageListing = ({ ManageListingsData }) => {
  const { ManageListings, loading } = ManageListingsData || {};

  return (
    <div>
      {!ManageListings && <Loader type="text" />}
      {ManageListings && <PanelWrapper data={ManageListingsData} />}
    </div>
  );
};

ManageListing.propTypes = {
  ManageListingsData: PropTypes.shape({
    loading: PropTypes.bool,
    ManageListings: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ])
  })
};

ManageListing.defaultProps = {
  ManageListingsData: {
    loading: true,
    ManageListings: []
  }
};

export default compose(
  withStyles(s),
  withQuery(ManageListingsQuery, {
    name: 'ManageListingsData',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
)(ManageListing);